<template>
  <div>
    <el-button-group class="button-group">
      <el-button type="default" @click="showModal()">
        + Dodaj nowe wideo
      </el-button>
    </el-button-group>
    <el-dialog
      title="Wgrywanie nowego wideo"
      append-to-body
      width="90vw"
      top="4vh"
      :visible.sync="modalVisible"
    >
      <splash-screen-video-upload-form @submit="onSubmit" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="hideModal()">Anuluj</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import SplashScreenVideoUploadForm from './forms/SplashScreenVideoUploadForm'

export default {
  components: { SplashScreenVideoUploadForm },
  data() {
    return {
      modalVisible: false
    }
  },
  methods: {
    showModal() {
      this.modalVisible = true
    },
    hideModal() {
      this.modalVisible = false
    },
    onSubmit() {
      this.hideModal()
      this.$emit('reload')
    }
  }
}
</script>
<style lang="scss" scoped>
.button-group {
  display: flex;
  justify-content: flex-end;
  padding-bottom: 10px;
}
</style>
